import { Pipe, PipeTransform } from '@angular/core';

import { thousandSeparatorAdd } from '@shared/utils';

@Pipe({
  standalone: false,
  name: 'thousandSeparator',
})
export class ThousandSeparatorPipe implements PipeTransform {
  transform(value: number | string, currencyCode: string): string {
    return thousandSeparatorAdd(value, currencyCode);
  }
}
